import { Avatar, Stack, Typography } from '@mui/material';
import { dotDateFormat } from 'Config';
import { format } from 'date-fns/esm';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { RegularCalendar } from 'Images';

interface ILastUpdated {
  lastUpdateDate?: Date;
}

export const LastUpdated = ({ lastUpdateDate }: ILastUpdated) => {
  return (
    <Stack
      gap={'6px'}
      direction={'row'}
      alignItems={'center'}
      width={'fit-content'}
    >
      <Avatar
        alt=''
        src={RegularCalendar}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant={'body6'} whiteSpace={'nowrap'}>
        {Dictionary[DICTIONARY.CompassRights].compassRightsHeader.lastUpdated}{' '}
        {lastUpdateDate
          ? format(new Date(lastUpdateDate), dotDateFormat)
          : null}
      </Typography>
    </Stack>
  );
};
